<div class="bg-dark side_nav shadow">
  <a routerLink="/admin" [routerLinkActive]="['active']"><i class="fa fa-users" aria-hidden="true"></i> Customers</a>
  <a  routerLink="/admin/contacts" [routerLinkActive]="['active']"><i class="fa fa-address-book" aria-hidden="true"></i>
     Contacts</a>
  <a routerLink="/admin/leads" ><i class="fa fa-id-card-o" aria-hidden="true"></i>
     Leads</a>
  <a routerLink="/admin/reports" ><i class="fa fa-flag" aria-hidden="true"></i>
     Reports</a>
</div>